export default __webpack_public_path__ + "static/media/org.c2185bb0.png";